module.exports = __webpack_public_path__ + "static/media/themeco.f79e0e4d.svg";